export default __webpack_public_path__ + "static/older-work-thumb-1400-90cc88116b3abc1bee2a8f7f582d1c01.jpg";